import React, { Component } from 'react';

class ScoreDial extends Component {

  getStylesForSize(size){
    switch(size){
      case 'large':
        return {
          outer: {
            width: '120px',
            height: '120px',
          },
          content: {
            lineHeight: '95px',
            fontSize: '32px'
          }
        }
      default:
      case 'medium':
        return {
          outer: {
            width: '60px',
            height: '60px',
          },
          content: {
            lineHeight: '45px',
            fontSize: '18px'
          }
        }
      break;
    }
  }

  render(){

    const {
      className,
      size,
      score,
      delta,
    } = this.props;

    const stylesForSize = this.getStylesForSize(size);

    return (
      <div className={`dial ${className} ${size}-ring`} style={stylesForSize.outer}>
        <div className="dial__progress" data-percent={score}></div>
        <div className="dial__content" style={stylesForSize.content}>{score}</div>
        {Number.isFinite(delta) && delta !== 0 &&
          <div className="diff-amount">{delta > 0 ? '+' : ''}{delta}</div>
        }
      </div>
    );
  }
}

export default ScoreDial;



// WEBPACK FOOTER //
// ./src/components/shared/scoreDial.js